import { Skeleton } from 'components/common/skeleton';

const MobilePropertyCardSkeleton = () => {
    return (
        <>
            <div className="ab-room-row-main">
                <div className="ab-room-image-container">
                    <div className="ab-room-image">
                        <Skeleton width={'100%'} height={220} />
                    </div>
                </div>
                <div className="ab-room-middle-container">
                    <div className="ab-room-middle-upper">
                        <div className="ab-room-upper-head">
                            <div className="ab-room-upper-name">
                                <Skeleton width={'60%'} height={12} mb={10} />
                            </div>
                            <span className="ab-small-score">
                                <div className="ab-stars">
                                    <Skeleton
                                        width={'40%'}
                                        height={12}
                                        mb={10}
                                    />
                                </div>
                                <span className="ab-small-score-inner">
                                    <Skeleton
                                        width={'30%'}
                                        height={12}
                                        mb={5}
                                    />
                                </span>
                            </span>
                            <div className="ab-room-upper-description">
                                <Skeleton width={'100%'} height={50} />
                            </div>
                        </div>
                        <div className="ab-room-upper-notes">
                            <div className="ab-room-upper-save ab-save-box">
                                <div className="ab-freebies">
                                    <div className="ab-skeleton ab-freebie">
                                        <Skeleton
                                            width={'40%'}
                                            height={25}
                                            mb={5}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="ab-room-upper-occupancy">
                                <Skeleton width={'50%'} height={8} />
                            </div>
                        </div>
                    </div>
                    <div className="ab-room-middle-footer">
                        <div className="ab-prices-div">
                            <div
                                className="ab-price"
                                tabIndex="0"
                                role="button"
                            >
                                <Skeleton width={'65%'} height={30} />
                            </div>
                        </div>
                        <div className="ab-buttons-div">
                            <div className="ab-book-button-container">
                                <div className="ab-book-button-content">
                                    <div
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                        }}
                                    >
                                        <Skeleton
                                            width={'65%'}
                                            height={30}
                                            ml={30}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ab-room-more-offers">
                <div className="ab-room-extra-offer ab-multi-channels-wrapper">
                    <div className="ab-desktop-widget-channels">
                        <Skeleton width={'30%'} height={40} mr={17} />
                        <Skeleton width={'30%'} height={40} mr={17} />
                        <Skeleton width={'30%'} height={40} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobilePropertyCardSkeleton;
